import {
	useMemo,
	Dropdown,
} from 'external/react'

import Icon from 'external/fortawesome'

import useAuth from 'context/auth-context/hook'
import usePayment from 'context/payment-context/hook'

export default function IconProfile (props) {

	const {path = 'home'} = props

	const {logout: logOut, user} = useAuth()
	const {dettachCart} = usePayment()

	const email = useMemo(() => user ? user.email : '',[user])

	function handleLogout () {
		dettachCart()
		logOut()
	}

	return (
		<li className='nav-item mr-1'>
			<Dropdown className='ml-1'>
				<Dropdown.Toggle variant='light' id='dropdown-basic'>
					<span>
						<Icon name="faCircleUser" className='img--user' />
						{email}
					</span>
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item href={`/${path}/profile`}>
						<span>
							<Icon name="faUser" /> Perfil
						</span>
					</Dropdown.Item>
					<Dropdown.Divider />
					<Dropdown.Item onClick={handleLogout}>
						<span>
							<Icon name="faRightFromBracket" /> Salir
						</span>
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</li>
	)
}